module.exports = __webpack_public_path__ + "static/media/WiLink_3.8a25a52e.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/WiLink_3.pdf
// module id = 905
// module chunks = 0